import { computed, toValue } from 'vue'
import { useCoreStore } from '@/shared/store'
import { OCR_KEYS, OCR_CODE } from '@/shared/constants/other.constants'
import { useFeaturesStore } from '@/shared/store/feature'

export const useOCRAvailability = () => {
  const coreStore = useCoreStore()
  const featuresStore = useFeaturesStore()
  const isOcrAvailable = computed<boolean>(() =>
    featuresStore.isOcrEnabled ? OCR_KEYS.includes(coreStore.getAbValue(OCR_CODE)) : false
  )

  return {
    isOcrAvailable: toValue(isOcrAvailable),
  }
}
